/**
 * Created by andrey on 20.05.2025
 */
import CleverAppsNative from "./cleverappsnative";
import Utils from "./utils";

const adUnits = {
    rewarded: {
        touch: "R-A-8148274-4",
        desktop: "R-A-8148274-5"
    },
    fullscreen: {
        touch: "R-A-8148274-1",
        desktop: "R-A-8148274-2"
    }
};

const YandexAds = {
    connect: function (callback) {
        window.yaContextCb = window.yaContextCb || [];

        Utils.loadSdk("//yandex.ru/ads/system/context.js", {
            onSuccess: () => {
                callback(CleverAppsNative.CODE_SUCCEED);
            }
        });
    },

    play: function (options, callback) {
        const platform = Ya.Context.AdvManager.getPlatform();

        let type = options.name;
        if (type === "interstitial") {
            type = "fullscreen";
        }

        const blockId = adUnits[type][platform];

        window.yaContextCb.push(
            Ya.Context.AdvManager.render({
                blockId,
                type,
                platform,
                onRewarded: function (isRewarded) {
                    console.log(`playAd onRewarded - ${isRewarded}`);
                    callback(isRewarded ? CleverAppsNative.CODE_SUCCEED : "closed_by_user");
                },
                onError: function (data) {
                    console.log("playAd error: ", data.type);
                    callback(`${options.name}_unknown_error`);
                },
                onClose: function () {
                    console.log("playAd fullscreen closed");
                    callback(CleverAppsNative.CODE_SUCCEED);
                }
            }, () => {
                console.log(`no ${options.name} ad`);
                callback(`${options.name}_not_found`);
            })
        );
    }
};

export default {
    install: function () {
        CleverAppsNative.addPlugin("YandexAds", YandexAds);
    }
};